
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SexesResponse } from "../../models/dtos";

export const sexesApi = createApi({
  reducerPath: 'sexesApi',
  baseQuery: baseAuthQuery('Sexes'),
  tagTypes: ['Sex'],
  endpoints: (builder) => ({
    getSexes: builder.query<ApiResponse<SexesResponse[]>, void>({
      query: () => "",
      providesTags: ['Sex'],
    }),
  }),
});
